// react components
import React from 'react'

// serializers
import {
    ContentTypeDetailPanelTypes,
} from 'serializers/site'

// props
type DetailContentTabButton825Props = {
    panel: ContentTypeDetailPanelTypes
    setTab: React.Dispatch<React.SetStateAction<number>>
    tab: number
}

// main
export const DetailContentTabButton825: React.FC<DetailContentTabButton825Props> = React.memo(({
    panel,
    setTab,
    tab,
}) => {
    return (
        <button
            key={panel.id}
            className={(tab === panel.id) ? 'dc-active' : ''}
            onClick={() => setTab(panel.id)}
        >
            {panel.title}
        </button>
    )
})
